import { render, staticRenderFns } from "./FeaturedPluginMain.vue?vue&type=template&id=5c98c0e8&"
import script from "./FeaturedPluginMain.vue?vue&type=script&lang=js&"
export * from "./FeaturedPluginMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports